import inventoryText from "../inventoryI18n.js";
import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import EditProduct from "./ProductEdit";
import "./Products.css";
import { API_URL } from "../../components/api";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";
import ExcelSVG from "../ExcelSVG.svg";
import FilterSVG from "../FilterSVG.svg";
import * as XLSX from "xlsx";
import Button from "react-bootstrap/Button";

import AuthContext from "../../context/AuthContext";

//For API Requests
import axios from "axios";

function ProductTable() {
  const [data, setData] = useState([]);
  const [group, setGroup] = useState("");
  console.log(group);
  const [showo, setShowo] = useState(false);
  const [dashoo, setDasho] = useState(false);

  const [loading, setLoading] = useState(true);

  const handleshowo = () => setShowo(true);
  const handleedit = () => setShowo(false);

  const [searchQuery, setSearchQuery] = useState("");
  const { user } = useContext(AuthContext);
  let authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const [DealerDetails, setDealerDetails] = useState({
    product_id: 0,
    code: "",
    description: "",
    barcode: "",
    name: "",
    price: 0,
    cost: 0,
    retail: 0,
    category: 0,
    supplier_id: null,
    supplier_name: "",
  });

  const [filters, setFilters] = useState({
    name: "",
    code: "",
    description: "",
    barcode: "",
    price: "",
    cost: "",
    retail: "",
    category: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });

  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  const updateDealerDetails = (details) => {
    setDealerDetails(details);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/inventory/products/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setData(response.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    const fetchGroups = async () => {
      try {
        const authTokens = JSON.parse(localStorage.getItem("authTokens"));
        const response = await axios.get(`${API_URL}/administration/groups/`, {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
          params: {
            username: user.username,
          },
        });

        if (response.status === 200) {
          setGroup(response.data);
        }
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
    fetchGroups();
  }, [user.username]);

  const columns = [
    { field: "name", headerName: inventoryText("inventory.Name"), flex: 2, minWidth: 50 },
    { field: "description", headerName: inventoryText("inventory.Description"), flex: 2, minWidth: 50 },
    { field: "code", headerName: inventoryText("inventory.Code"), flex: 2, minWidth: 50 },
    { field: "barcode", headerName: inventoryText("inventory.Barcode"), flex: 2, minWidth: 50 },
    {
      field: "supplier_name",
      headerName: inventoryText("inventory.Supplier"),
      flex: 2,
      minWidth: 100,
      valueGetter: (params) => params.row.supplier_name || "-",
    },
    { field: "category_name", headerName: inventoryText("inventory.Category"), flex: 2, minWidth: 50 },

    ...(group === "yes"
      ? [
          {
            field: "cost",
            headerName: inventoryText("inventory.Cost"),
            flex: 1,
            minWidth: 60,
            valueFormatter: (params) => {
              // Format the value by adding a dollar sign
              return `$ ${params.value}`;
            },
          },
        ]
      : []),
    {
      field: "selling_price",
      headerName: inventoryText("inventory.Price"),
      flex: 1,
      minWidth: 60,
      valueFormatter: (params) => {
        // Format the value by adding a dollar sign
        return `$ ${params.value}`;
      },
    },
    {
      field: "is_active",
      headerName: inventoryText("inventory.Status"),
      flex: 1,
      minWidth: 100,
      valueGetter: (params) =>
        params.row.is_active === 0 || params.row.is_active === false
          ? inventoryText("inventory.Inactive")
          : inventoryText("inventory.Active"),
    },
    ...(group === "yes"
      ? [
          {
            field: "retail_price",
            headerName: inventoryText("inventory.RetailPrice"),
            flex: 1,
            minWidth: 60,
            valueFormatter: (params) => {
              // Format the value by adding a dollar sign
              return `$ ${params.value}`;
            },
          },
        ]
      : []),
    {
      field: "actions",
      headerName: inventoryText("inventory.Actions"),
      minwidth: 100,
      flex: 2,
      renderCell: (params) => (
        <div>
          <button
            className="edit-client"
            onClick={() => {
              const details = {
                product_id: params.row.product_id,
                description: params.row.description,
                code: params.row.code,
                name: params.row.name,
                barcode: params.row.barcode,
                price: params.row.selling_price,
                retail: params.row.retail_price,
                cost: params.row.cost,
                category: params.row.category_id,
                category_name: params.row.category_name,
                supplier_id: params.row.supplier_id,
                supplier_name: params.row.supplier_name,
              };
              updateDealerDetails(details);
              handleshowo();
            }}
          >{inventoryText("inventory.Edit")}</button>
        </div>
      ),
    },
  ];

  const getRowId = (row) => row.product_id;

  // Create a delayed search filter function
  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchProduct");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchProduct") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchProduct", searchValue);
      setSearchQuery(searchValue);
      setSearchInput(searchValue);
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchProduct", query);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 100);
    setSearchFilterTimeout(newTimeout);
  };

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      if (key === "connectivity_dependent") {
        const filterValue = filters[key].toLowerCase();
        if (row.connectivity === "Fiber") {
          return (row.code || "").toLowerCase().includes(filterValue);
        } else if (row.connectivity === "Wireless") {
          return (row.name || "").toLowerCase().includes(filterValue);
        }
        return false;
      }

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  // Define the column headers mapping
  const columnHeaders = {
    name: "Name",
    description: "Description",
    code: "Code",
    barcode: "Barcode",
    supplier_name: "Supplier",
    category_name: "Category",
    cost: "Cost",
    selling_price: "Price",
    retail_price: "Retail Price",
    is_active: "Status",
  };

  // Format date fields properly for export — e.g. "21/02/2025 10:25:52 AM"
  const formatDateForExport = (dateValue) => {
    if (!dateValue) return "";
    const date = new Date(dateValue);

    // Format as DD/MM/YYYY HH:MM:SS AM/PM
    const formattedDate = date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: true,
    });

    // Ensure consistent spacing before AM/PM
    return formattedDate.replace(" am", " AM").replace(" pm", " PM");
  };

  /// Corrected: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Only export if column is visible
        if (columnVisibilityModel[field] !== false) {
          const headerName = columnHeaders[field];

          // Default: use the value or empty string
          transformedRow[headerName] = row[field] ?? "";
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");
    XLSX.writeFile(workbook, "Products.xlsx");
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        className="product-toolbar-action"
        onClick={() => setShowFilterModal(true)}
      >
        <img
          className="product-toolbar-icon"
          src={FilterSVG}
          alt=""
        />{inventoryText("inventory.Filter")}</Button>
      <GridToolbarExport />
      <Button
        className="product-toolbar-action"
        onClick={handleExportToExcel}
      >
        <img
          className="product-toolbar-icon"
          src={ExcelSVG}
          alt=""
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  //Datatable HTML
  return (
    <div className="ClientTable inventory-products-table">
      <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
      <input
        type="text"
        placeholder={inventoryText("inventory.Search")}
        value={searchInput}
        onChange={handleSearchChange}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      <Modal
        show={showo}
        onHide={handleedit}
        className="product-edit-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>{inventoryText("inventory.EditProducts")}</Modal.Title>
        </Modal.Header>
        <EditProduct
          product_id={DealerDetails.product_id}
          name={DealerDetails.name}
          code={DealerDetails.code}
          description={DealerDetails.description}
          barcode={DealerDetails.barcode}
          cost={DealerDetails.cost}
          price={DealerDetails.price}
          category={DealerDetails.category}
          category_name={DealerDetails.category_name}
          supplier_id={DealerDetails.supplier_id}
          supplier_name={DealerDetails.supplier_name}
          retail={DealerDetails.retail}
        />
      </Modal>
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{inventoryText("inventory.Filters")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {columns
            .filter((col) => col.field !== "actions")
            .map((col) => (
              <div key={col.field} className="filter">
                <label>{col.headerName}</label>
                <input
                  type="text"
                  placeholder={`Filter by ${col.headerName}`}
                  value={filters[col.field] || ""}
                  onChange={(e) =>
                    handleFilterChange(col.field, e.target.value)
                  }
                  className="filter-input"
                />
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>{inventoryText("inventory.Close")}</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ProductTable;
